import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { tabTypes, TTabId } from './constants';
import { compassIcon, pinIcon } from './icons';
import styles from './index.css';
import { RoadCommuteRow } from './road_commute_row';
import { StationCommuteRow } from './station_commute_row';
import { NavigationLinkTypes } from '../../constants/navigation';
import { trackMapTabClick } from '../../tracking/trackMapTabClick';
import { IGeoSchema, IRoadInfoSchema, IStationInfoSchema } from '../../types';
import { VillageMapContainer } from '../map/container';

export interface IMapBlockProps {
  geo?: IGeoSchema;
  generalPlanUrl?: string;
  commuteHighway: IRoadInfoSchema;
  commuteRailway: IStationInfoSchema;
  regionId?: number;
  regionHasRoads: boolean;
  regionHasStations: boolean;
}

export interface IMapBlockDispatchProps {
  setNavigationLink(): void;
}

type TProps = IMapBlockProps & IMapBlockDispatchProps;

interface IMapBlockState {
  activeTab: TTabId;
}

function createTabTitle(text: string, icon: JSX.Element) {
  return (
    <span>
      <span className={styles['tab-icon']}>{icon}</span>
      {text}
    </span>
  );
}

const mapTab = {
  id: tabTypes.map,
  title: createTabTitle('На карте', pinIcon),
};
const generalPlanTab = {
  id: tabTypes.generalPlan,
  title: createTabTitle('Генплан', compassIcon),
};

export class MapBlock extends React.Component<TProps, IMapBlockState> {
  public constructor(props: TProps) {
    super(props);

    this.state = {
      activeTab: tabTypes.map,
    };
  }

  public componentDidMount() {
    this.props.setNavigationLink();
  }

  public render() {
    const { geo } = this.props;

    const address = geo?.address?.details?.map((addr, index) => {
      const url = addr.seo ? addr.seo.url : '';

      const addressItem = (
        <a className={styles['address-link']} href={url} key={index} target="_blank">
          {addr.fullName}
        </a>
      );

      return [index > 0 && ', ', addressItem];
    });

    return (
      <div className={styles['container']} id={NavigationLinkTypes.Map}>
        <div className={styles['header']}>
          <div className={styles['address']}>{address}</div>
          {this.renderHighway()}
          {this.renderStation()}
        </div>
        <div className={styles['content']}>
          {this.renderTabs()}
          {this.renderTabContent()}
        </div>
      </div>
    );
  }

  private renderHighway() {
    const { commuteHighway, regionHasRoads, regionId } = this.props;

    return regionHasRoads && commuteHighway ? RoadCommuteRow(commuteHighway, regionId) : null;
  }

  private renderStation() {
    const { commuteRailway, regionHasStations } = this.props;

    return regionHasStations && commuteRailway ? StationCommuteRow(commuteRailway) : null;
  }

  private renderTabs() {
    const tabs = this.props.generalPlanUrl ? [mapTab, generalPlanTab] : [mapTab];

    return (
      <div className={styles['tabs']}>
        {tabs.map(({ id, title }) => (
          <button
            key={`tab_${id}`}
            {...mergeStyles(styles['tab'], this.state.activeTab === id && styles['tab--active'])}
            onClick={() => this.handleTabChange(id)}
          >
            {title}
          </button>
        ))}
      </div>
    );
  }

  private handleTabChange = (tab: TTabId) => {
    this.setState({ activeTab: tab });
    trackMapTabClick(tab);
  };

  private renderTabContent() {
    return this.state.activeTab === tabTypes.map ? (
      <VillageMapContainer />
    ) : (
      <img src={this.props.generalPlanUrl} className={styles['general-plan']} />
    );
  }
}
